<div class="event-switcher-header" *ngIf="showHeader">
    <div class="event-switcher-header-item">{{ title }}</div>
    <button ds-button-icon kind="tertiary" variant="flat" size="medium" (click)="close()">
        <vn-icon name="theme-ex" size="16" class="close"></vn-icon>
    </button>
</div>
<ms-nav-tree msTreeScroll [hideHeader]="!showHeader" [tree]="tree" (toggle)="toggleItem($event)" (selectEvent)="onSelectEvent($event)"> </ms-nav-tree>
